import { BOARD_CONFIG } from '@/(routers)/boards/editor/block/blockConfig';
import { registerSetupCode, registerWireBegin } from '@/(routers)/boards/editor/block/generators/arduino/_gen';

type BoardType = keyof typeof BOARD_CONFIG;
type Position = keyof (typeof BOARD_CONFIG)[BoardType]['pins'];

export function registerOledInit(board: BoardType, position: Position): void {
    const pins = BOARD_CONFIG[board].pins[position];
    const wireBegin = board === 'blue' ? `Wire.begin(${pins.first}, ${pins.second});` : 'Wire.begin();';
    registerWireBegin(`  ${wireBegin}\n`);
    registerSetupCode(
        'oled_init',
        `  oled.begin(SSD1306_SWITCHCAPVCC, 0x3C, false, false);\n  oled.clearDisplay();\n`,
    );
}
